import create from "zustand";
import { devtools } from "zustand/middleware";
import {
  defaultWeb3ButtonState,
  DEFAULT_WEB_3_BUTTON_ACTIONS,
  DEFAULT_WEB_3_BUTTON_STATE,
} from "./Web3ButtonInterface";

export const useWeb3Button = create<DEFAULT_WEB_3_BUTTON_ACTIONS&DEFAULT_WEB_3_BUTTON_STATE>()(
  devtools((set) => ({
    ...defaultWeb3ButtonState,
    initiatingRequest: (type: string) => {
      set((state) => ({
        ...state,
        transactionType: type,
        isRequestInitiated: true,
        isTransactionFailed: false,
        isTransactionProcessing: false,
        isTransactionSuccessful: false,
      }));
    },
    processingRequest: (txId: string) => {
      set((state) => ({
        ...state,
        isRequestInitiated: false,
        isTransactionFailed: false,
        isTransactionProcessing: true,
        isTransactionSuccessful: false,
        transactionId: txId,
      }));
    },
    requestSuccessful: () => {
      set((state) => ({
        ...state,
        isRequestInitiated: false,
        isTransactionFailed: false,
        isTransactionSuccessful: true,
        isTransactionProcessing: false,
      }));
    },
    requestFailed: () => {
      set((state) => ({
        ...state,
        isRequestInitiated: false,
        isTransactionFailed: true,
        isTransactionProcessing: false,
        isTransactionSuccessful: false,
      }));
    },
    resetWeb3ButtonState: () => {
      set((state) => ({
        ...state,
        isRequestInitiated: false,
        isTransactionFailed: false,
        isTransactionProcessing: false,
        isTransactionSuccessful: false,
        transactionId: "",
        transactionType: "",
      }));
    },
  }))
);
